export default "__VITE_ASSET__CW_mu55p__"